
















































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import Config from '@/config';
import users from '@/store/modules/users';

@Component
export default class RegisterForm extends Vue {
  private form: any = {
    email: '',
    password: '',
    repeatPassword: '',
    role: '',
  };

  private data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Please select a role' },
        { value: 'ADMIN', text: 'ADMIN' },
        { value: 'MANAGER', text: 'MANAGER' },
        { value: 'USER', text: 'USER' },
      ],
    };
  }

  private async onSubmit(event: any) {
    event.preventDefault();
    const validation = this.validateForm();
    if (validation === true) {
      try {
        const response = await users.registerUser({
          email: this.form.email,
          password: this.form.password,
          role: this.form.role,
        });
      } catch (err) {
        this.$emit('error', err.message);
      }
    } else {
      this.$emit('error', validation);
    }
  }

  private validateForm() {
    if (this.form.password !== this.form.repeatPassword) {
      return 'Passwords don\'t match';
    }

    if (this.form.role === null) {
      return 'You should select a role for the user';
    }

    return true;
  }
}
